import React from "react";

export const CaretRightFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ?? 8}
    height={props.height ?? 13}
    viewBox="0 0 8 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
<path opacity="0.8" d="M7.5 6.49609L0 12.9913L0 0.00090313L7.5 6.49609Z" fill={props.fill ?? "currentColor"}/>
  </svg>
);

export default CaretRightFilledIcon;



